import React, { ReactElement } from 'react';
import cm from 'classnames';

import { useAppDispatch, useAppSelector } from 'store/store-hooks';
import { selectHelpMode } from 'components/app/_mediator/app-data.slice';
import {
  ProjectTableStateKey,
  PROJECT_TABLES_STATE,
  setTableState,
} from 'components/app/projects/_mediator/projects.slice';

import { ReactComponent as PlusIcon } from 'assets/ui/plus.svg';
import { ReactComponent as MinusIcon } from 'assets/ui/minus.svg';
import { TooltipHelp } from 'components/UI/tooltip/tooltip-help';
import { Tooltip } from 'components/UI/tooltip/tooltip';
import styles from '../_sections.module.scss';

type Props = {
  expanded: boolean;
  keyTableState: ProjectTableStateKey;
  title: string;
  projectName?: string;
  children: React.ReactNode;
  empty: boolean;
  len: number;
  tip?: string | ReactElement;
};

export const SectionHeader = ({ expanded, keyTableState, projectName, title, len, empty, children, tip }: Props) => {
  const helpMode = useAppSelector(selectHelpMode);
  const dispatch = useAppDispatch();

  const handleClick = (e: React.MouseEvent) => {
    dispatch(setTableState({ key: keyTableState, value: !expanded }));
    if (e.shiftKey)
      PROJECT_TABLES_STATE.forEach((key) => {
        key !== keyTableState && dispatch(setTableState({ key, value: expanded }));
      });
  };

  const hint = `${title} table: click to ${expanded ? 'collapse' : 'expand'} (Shift: ${
    expanded ? 'expand' : 'collapse'
  } all others)`;

  const Tip = () => (
    <TooltipHelp>
      <p>{hint}</p>
      {tip}
    </TooltipHelp>
  );

  return (
    <Tooltip tip={tip ? <Tip /> : hint} showTooltip={helpMode} position="bottom" dynamicPosition>
      <div className={cm(styles.SectionHeader)}>
        <div className={styles.SectionHeader__wrapper} onClick={handleClick} data-testid="table-header">
          <div className={styles.SectionHeader__expandIcon}>{expanded ? <MinusIcon /> : <PlusIcon />}</div>
          <b>
            {title} ({len}){projectName ? ':' : ''}
          </b>
          {projectName && `${projectName}`}
        </div>
        {!empty && children}
      </div>
    </Tooltip>
  );
};
